import { useMemo, useCallback } from 'react';

import { CheckboxSlider } from 'ui-components/components/checkbox-slider';

import styles from './styles.module.less';
import DataDrivenLogo from '../../../../../../../../../../../components/data-driven-logo';

/**
 *
 * @param {object} props
 * @param {string} props.idPrefix
 * @param {object[]} props.connections
 * @param {Array<{connectionId: string, terminusType: string}>} props.selectedConnections
 * @param {(connectionId: string) => void} props.onToggle
 * @returns {JSX.Element} A component that renders a list of connections
 */
export const ConnectionList = ({ idPrefix, connections, selectedConnections, onToggle }) => {
  const isChecked = useMemo(
    () => (connectionId) => selectedConnections.some((connection) => connection.connectionId === connectionId),
    [selectedConnections],
  );

  const handleToggle = useCallback((connectionId) => onToggle(connectionId), [onToggle]);

  return (
    <ul className={styles['sync-targets']}>
      {connections.map(({ name, disabled, connectionId, marketplaceId, fillProviderId }) => {
        const id = `${idPrefix}-${connectionId}`;
        return (
          <li key={id} className={styles['sync-target']}>
            <DataDrivenLogo
              className={styles['target-icon']}
              fillProviderId={fillProviderId}
              logoType='icon'
              marketplaceId={marketplaceId}
            />
            <CheckboxSlider
              checkboxId={id}
              checked={isChecked(connectionId)}
              className={styles['checkbox-field']}
              disabled={disabled}
              labelText={name}
              onChange={() => handleToggle(connectionId)}
            />
          </li>
        );
      })}
    </ul>
  );
};
